module.exports = __webpack_public_path__ + "img/user-task.90bd34cf.svg";